/**
 * Coin stack icon for Credits menu / wallet actions.
 */
import React from "react";

export default function CoinsIcon({
    strokeWidth = 2.1,
    className = "w-1",
    stroke = "currentColor",
    fill = "none",
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            fill={fill}
            viewBox="0 0 24 24"
            stroke={stroke}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
        </svg>
    );
}
